import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageViewTracker() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      setTimeout(() => {
        posthog.capture("$pageview", {
          $current_url: window.location.href,
        });
      }, 0);
    }
  }, [posthog, location]);

  return null;
}
